.shell {
    display: flex;
    flex-direction: column;
    height: 100vh;
}

.content {
    display: flex;
    flex: 1;
    overflow: hidden;
}

.mainArea {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;
}

.main {
    flex: 1;
    overflow-y: auto;
    padding: var(--exo-spacing-x-large);
    background: var(--exo-color-background-secondary);
}

.unauthorizedMain {
    flex: 1;
    background: var(--exo-color-background-secondary);
}
